import angular from 'angular';
import '../services/organization-condition';
import '../services/errors';
import './modals/organization-condition';

const module = angular.module('whyline.controllers.organization-conditions', [
  'whyline.modals.organization-condition',
  'whyline.services.organization-condition',
  'whyline.services.errors',
]);

const OrganizationConditionsController = (
  $scope,
  $uibModal,
  $window,
  $translate,
  OrganizationConditionService,
  NotificationService,
  ErrorService,
  dialog,
) => {
  /*@ngInject*/

  // View init
  OrganizationConditionService.GetAllAsPromiseFromServer().then((data) => {
    $scope.organizationConditions = data;
  });

  $scope.quantityOfItems = 8;

  // Modal
  $scope.open = (organizationConditionId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/organization-condition-modal.html',
      size: 'lg',
      controller: 'OrganizationConditionModalController',
      resolve: {
        organizationConditionId: () => organizationConditionId,
      },
    });
  };

  $scope.remove = (condition) => {
    let n = condition.slug || '';
    dialog
      .confirm($translate.instant('condition_{name}_remove_sure').replace('{name}', n))
      .then(() => {
        const conditionId = condition._id;

        OrganizationConditionService.Remove(conditionId)
          .then(() => {
            let name_tags = `<span class="bold">${name || ''}</span>`;
            NotificationService.Success(
              $translate.instant('condition_remove_succ').replace('{name}', name_tags),
            );

            OrganizationConditionService.GetAllAsPromiseFromServer().then((data) => {
              $scope.organizationConditions = data;
            });
          })
          .catch((err) => {
            if (err && err.status === 409) {
              const {
                data: {
                  error: { code, references },
                },
              } = err;

              const referencesHtml = references.join('<br />');

              const message = $translate.instant(code).replace('{references}', referencesHtml);

              NotificationService.Warning(message);
            } else {
              ErrorService.handler(err);
            }
          });
      });
  };
};

module.exports = module.controller(
  'OrganizationConditionsController',
  OrganizationConditionsController,
);
